import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Sidebar from "./components/layout/Sidebar";
import Navbar from "./components/layout/Navbar";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MailIcon from "@mui/icons-material/Mail";
import SendIcon from "@mui/icons-material/Send";
import BarChartIcon from "@mui/icons-material/BarChart";
import HistoryIcon from "@mui/icons-material/History";
import AutomationIcon from "@mui/icons-material/Settings";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PersonIcon from "@mui/icons-material/Person";
import ReceiptIcon from "@mui/icons-material/Receipt";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";

// Pages
import Dashboard from "./pages/Dashboard";
import DataUpload from "./pages/DataUpload";
import EmailTemplates from "./pages/EmailTemplates";
import BulkMessaging from "./pages/BulkMessaging";
import Analytics from "./pages/Analytics";
import MessageHistory from "./pages/MessageHistory";
import AutomationSettings from "./pages/AutomationSettings";
import Actions from "./pages/Actions";
import Profile from "./pages/Profile";
import AIFollowUps from "./pages/AIFollowUps";
import Billing from "./pages/Billing";
import MarketingServices from "./pages/MarketingServices";
import CreateInvoice from "./pages/billing/CreateInvoice";
import PaymentGateway from "./pages/billing/PaymentGateway";
import InvoiceTemplates from "./pages/billing/InvoiceTemplates";
import RecurringInvoices from "./pages/billing/RecurringInvoices";
import PaymentCollection from "./pages/billing/PaymentCollection";
import PaymentReminders from "./pages/billing/PaymentReminders";
import InvoiceHistory from "./pages/billing/InvoiceHistory";
import FinancialReports from "./pages/billing/FinancialReports";
import PaymentSuccess from "./pages/billing/PaymentSuccess";
import CustomerPortal from "./pages/billing/CustomerPortal";
import Customers from "./pages/Customers";
import Settings from "./pages/Settings";

const queryClient = new QueryClient();

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
});

function App() {
  const menuItems = [
    {
      text: "Dashboard",
      icon: <DashboardIcon />,
      path: "/",
    },
    // {
    //   text: 'Data Upload',
    //   icon: <CloudUploadIcon />,
    //   path: '/data-upload'
    // },
    // {
    //   text: 'Email Templates',
    //   icon: <MailIcon />,
    //   path: '/email-templates'
    // },
    // {
    //   text: 'Bulk Messaging',
    //   icon: <SendIcon />,
    //   path: '/bulk-messaging'
    // },
    // {
    //   text: 'AI Follow-ups',
    //   icon: <AutorenewIcon />,
    //   path: '/ai-followups'
    // },
    // {
    //   text: 'Analytics',
    //   icon: <BarChartIcon />,
    //   path: '/analytics'
    // },
    // {
    //   text: 'Message History',
    //   icon: <HistoryIcon />,
    //   path: '/message-history'
    // },
    // {
    //   text: 'Automation',
    //   icon: <AutomationIcon />,
    //   path: '/automation'
    // },
    // {
    //   text: 'Actions',
    //   icon: <PlayArrowIcon />,
    //   path: '/actions'
    // },
    // {
    //   text: 'Profile',
    //   icon: <PersonIcon />,
    //   path: '/profile'
    // },
    // {
    //   text: 'Messaging Services',
    //   icon: <SendIcon />,
    //   path: '/messaging'
    // },
    // {
    //   text: 'Billing',
    //   icon: <ReceiptIcon />,
    //   path: '/billing'
    // }
  ];

  return (
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <div className="flex h-screen bg-gray-100">
            <Sidebar menuItems={menuItems} />
            <div className="flex-1 flex flex-col overflow-hidden">
              <Navbar />
              <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-6">
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/data-upload" element={<DataUpload />} />
                  <Route path="/email-templates" element={<EmailTemplates />} />
                  <Route path="/bulk-messaging" element={<BulkMessaging />} />
                  <Route path="/analytics" element={<Analytics />} />
                  <Route path="/message-history" element={<MessageHistory />} />
                  <Route path="/automation" element={<AutomationSettings />} />
                  <Route path="/actions" element={<Actions />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/ai-followups" element={<AIFollowUps />} />
                  <Route
                    path="/marketing-services"
                    element={<MarketingServices />}
                  />
                  <Route path="/billing" element={<Billing />} />
                  <Route
                    path="/billing/create-invoice"
                    element={<CreateInvoice />}
                  />
                  <Route path="/billing/payment" element={<PaymentGateway />} />
                  <Route
                    path="/billing/payment-success"
                    element={<PaymentSuccess />}
                  />
                  <Route
                    path="/billing/templates"
                    element={<InvoiceTemplates />}
                  />
                  <Route
                    path="/billing/recurring"
                    element={<RecurringInvoices />}
                  />
                  <Route
                    path="/billing/payments"
                    element={<PaymentCollection />}
                  />
                  <Route
                    path="/billing/reminders"
                    element={<PaymentReminders />}
                  />
                  <Route path="/billing/history" element={<InvoiceHistory />} />
                  <Route
                    path="/billing/reports"
                    element={<FinancialReports />}
                  />
                  <Route
                    path="/billing/customer-portal"
                    element={<CustomerPortal />}
                  />
                  <Route path="/customers" element={<Customers />} />
                  <Route path="/settings" element={<Settings />} />
                </Routes>
              </main>
            </div>
          </div>
        </Router>
      </QueryClientProvider>
    </ChakraProvider>
  );
}

export default App;
